$(document).ready(() => {
  const form = $('form#subscriptionIntentionsSelectionForm');

  if (form.length == 0) {
    return;
  }

  const resultTable = $('#selection-result-table');

  form.on('submit', function (event) {
    form.find('input').prop('readonly', true);
    form.find('input[type=submit]').prop('disabled', true);
    form.find('input').addClass('disabled');
    form.find('#loader').removeClass('d-none');
    form.find('#message').html('');
    form.find('#message').addClass('d-none');
    return true;
  });

  function allowSubmit() {
    form.find('input').prop('readonly', false);
    form.find('input[type=submit]').prop('disabled', false);
    form.find('input').removeClass('disabled');
    form.find('#loader').addClass('d-none');
  }

  App.cable.subscriptions.create(
    { channel: 'SubscriptionIntentionsSelectionChannel', project_id: form.data('projectId') }, {
      received(data) {
        form.find('#message').html(data.message);
        form.find('#message').removeClass('d-none');

        allowSubmit();

        if (data.status === 'success') {
          form.find('#message').removeClass('admin-error-span');
          form.find('#message').addClass('status-ok');

          $.ajax({ type: 'GET', url: resultTable.data('url') });
        } else {
          form.find('#message').removeClass('status-ok');
          form.find('#message').addClass('admin-error-span');

          if (!data.message) {
            form.find('#message').html('An error occurred. Please try again later.');
          }
        }
      },
      rejected() {
      },
    });
});
